import React from 'react';
import { ConstantsMobile } from '@/mobile/utils/constants';
import QuitTextMobileData from './texts/QuitTextMobileData';
import QuitTextMobileSMS from './texts/QuitTextMobileSMS';
import QuitTextMobileVoice from './texts/QuitTextMobileVoice';

type Props = {
  identifier: string;
};

/**
 * 「解約画面」の重要事項制御コンポーネント。
 */
const QuitTextProvider = ({ identifier }: Props) => {
  // 契約種別ごとに注意事項が異なるため、文言コンポーネントをここで統一的に切り替える。
  if (identifier === ConstantsMobile.Quit.ContractType.MOBILE_DATA) {
    return <QuitTextMobileData />;
  }
  if (identifier === ConstantsMobile.Quit.ContractType.MOBILE_SMS) {
    return <QuitTextMobileSMS />;
  }
  if (identifier === ConstantsMobile.Quit.ContractType.MOBILE_VOICE) {
    return <QuitTextMobileVoice />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default QuitTextProvider;
